<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="showMenuButton">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <ion-title>{{ pageTitle }}</ion-title>

    <ion-buttons slot="end">
      <div class="college-logo-container" *ngIf="showCollegeLogo && hasCollegeLogo()">
        <img [src]="collegeLogo" alt="College Logo" class="college-logo-image" />
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>